import { ReactNode, Fragment } from 'react'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'

import { FlexFiller, classes as commonStyles } from '../../theme/common-styles'

interface SelectionToolbarProps {
    numberOfSelectedItems: number
    selectedActions: ReactNode[]
}

export function SelectionToolbar({ numberOfSelectedItems, selectedActions }: SelectionToolbarProps) {
    if (numberOfSelectedItems === 0) return null
    return (
        <Toolbar sx={commonStyles.toolbarHighlighted}>
            <Typography variant="h6" component="div">
                {numberOfSelectedItems} selected
            </Typography>
            <FlexFiller />
            {selectedActions.map((c, i) => (
                <Fragment key={i}>{c}</Fragment>
            ))}
        </Toolbar>
    )
}
